import { createContext, ReactNode, useContext } from 'react';
import {
  ALL_SURVEY_ACTIONS,
  allowedActions,
  mayTake,
  SurveyAction,
} from '../pages/WorkEnvironmentSurveyDetail/surveyActions';

const SurveyActionsContext = createContext<ReadonlySet<SurveyAction>>(
  new Set(ALL_SURVEY_ACTIONS),
);

/** The survey page tells its cards what the viewer may do, so each card asks one place */
export const SurveyActionsProvider = ({
  actions,
  children,
}: {
  actions: SurveyAction[] | undefined;
  children: ReactNode;
}) => (
  <SurveyActionsContext.Provider value={allowedActions(actions)}>
    {children}
  </SurveyActionsContext.Provider>
);

export const useSurveyActions = () => {
  const allowed = useContext(SurveyActionsContext);
  return { may: (action: SurveyAction) => mayTake(allowed, action) };
};
